export default __webpack_public_path__ + "static/vue-8a74d93fde1a02c247304291cce46797.jpg";